import { render } from "./ProyectosView.vue?vue&type=template&id=018d6fba&scoped=true"
import script from "./ProyectosView.vue?vue&type=script&lang=js"
export * from "./ProyectosView.vue?vue&type=script&lang=js"

import "./ProyectosView.vue?vue&type=style&index=0&id=018d6fba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018d6fba"]])

export default __exports__